import TradeInProvider from 'trade-in-360/TradeInProvider.jsx';
import TradeInWrapper from 'trade-in-360/components/TradeInWrapper/TradeInWrapper.jsx';
import InstantEstimateProvider from 'trade-in-360/InstantEstimateProvider.jsx';
import OfficialTradeInProvider from 'trade-in-360/OfficialTradeInProvider.jsx';
import TradeInBarWrapper from 'trade-in-360/components/TradeInBarWrapper/TradeInBarWrapper.jsx';
import TradeInTiles from 'trade-in-360/components/TradeInTiles/TradeInTiles.jsx';

import en from 'trade-in-360/i18n/en.json';
import fr from 'trade-in-360/i18n/fr.json';

const root = TradeInWrapper;
const provider = TradeInProvider;
const main = provider;

const i18n = {
    en,
    fr,
};

export const widgets = {
    TradeIn360: {
        components: {
            root,
            main,
            provider,
            TradeInBarWrapper,
            TradeInTiles,
        },
        i18n,
        InstantEstimateProvider,
        OfficialTradeInProvider,
    },
};

export default {
    TradeIn360: main,
    Translations: i18n,
    root,
    provider,
    InstantEstimateProvider,
    OfficialTradeInProvider,
    components: {
        TradeInBarWrapper,
        TradeInTiles,
    },
};
